module.exports = __webpack_public_path__ + "static/img/botian.7e5c1cfb.png";